/**
 * 협력업체 로그인 (/p/login) — 본사·지사·센터·발주자 로그인. 개발 IP 에선 소속을 골라 바로 들어가는 칸이 더 있다.
 * ($j.Pages.Partner.PartnerLogin / body data-page-type="Partner" data-page-name="PartnerLogin")
 *
 * 지난번 고른 로그인 유형(쿠키)은 #page-data 로 받는다.
 */
export default class PartnerLogin {
    initialize() { initialize(); }
}

function formCheck(){
    var form = document.memlogin;
    if( !$("input[name='logintype']:checked").val()){
        alert("로그인 유형을 선택해 주세요");return;
    }
    if(form.mem_id.value==""){
        alert("아이디를 입력해 주세요");
        form.mem_id.focus();
        return false;
    }else if(form.mem_pwd.value==""){
        alert("비밀번호 입력해 주세요");
        form.mem_pwd.focus();
        return false;
    }
    form.submit();
}

function setno(n, s){
}


function selectIt(){
    // 본사,지사는 선택되어야 한다.
    const bsanum = $('#ref-bonsa').val();
    const gsanum = $('#ref-gisa').val();
    const center = $('#ref-center').val();
    if( !bsanum ) {
        $('#ref-bonsa').focus();
        alert('본사를 선택해주세요.');
        return;
    }
    let sosokCode = center;
    if(!sosokCode) sosokCode=gsanum;
    if(!sosokCode) sosokCode=bsanum;
    document.memlogin.code.value=sosokCode;
    document.memlogin.submit();
}
const sosoks = null;
function initialize(){
    const loginType = JSON.parse(document.getElementById('page-data').textContent).loginType || '';
    $('input[type="radio"][name="logintype"][value="'+loginType+'"]').prop('checked', true);

    // 엔터 전송은 formCheck 가 false 를 돌려줄 때만 막는다 — 예전 onsubmit="return formCheck();" 와 같은 판정
    $('form[name=memlogin]').on('submit', (e) => { if (formCheck() === false) e.preventDefault(); });
    $('#btnLogin').on('click', (e) => { e.preventDefault(); formCheck(); });
    $('#btnSelectSosok').on('click', selectIt);


    // 본사,지사 이벤트핸들러등록
    $j.Common.Form.registerBonsaHandler('ref-bonsa','ref-gisa','ref-center');
    $j.Common.Form.registerGisaHandler('ref-gisa','ref-center');
    // 본사 업데이트
    $j.Common.Form.updateBonsaSelectBox(sosoks, 'ref-bonsa','ref-gisa','ref-center');
}

